<ng-container *transloco="let t; read: 'settings'">
<h2 class="mbm">{{ t('ressources') }}</h2>
<kendo-grid
  [data]="ressources"
  (edit)="editHandler($event)"
  (cancel)="cancelHandler($event)"
  (save)="saveHandler($event)"
  (remove)="removeHandler($event)"
  (add)="addHandler($event)"
  [style.maxHeight.px]="600"
>
  <ng-template kendoGridToolbarTemplate>
    <button kendoGridAddCommand>{{ t('add') }}</button>
  </ng-template>
  <kendo-grid-column field="name" [title]="t('name')">
    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup"
    >
      <kendo-textbox
            [readonly]="dataItem.employee"
            [formControl]="formGroup.get('name')"
        >
        </kendo-textbox>
    </ng-template>
  </kendo-grid-column>

    <kendo-grid-column field="nameShort" [title]="t('abbreviation')"></kendo-grid-column>

  <kendo-grid-column field="ressourceCategory" [title]="t('category')">
    <ng-template kendoGridCellTemplate let-dataItem>
        {{dataItem.ressourceCategory?.name ?? t('employee')}}
    </ng-template>

    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup"
    >
      <kendo-dropdownlist
            [readonly]="dataItem.employee"
            [data]="ressourceCategories"
            textField="name"
            valueField="id"
            [valuePrimitive]="false"
            [formControl]="formGroup.get('ressourceCategory')"
        >
        </kendo-dropdownlist>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="isHidden" [title]="t('hidden')" editor="boolean">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{dataItem.isHidden ? t('yes') : t('no')}}
  </ng-template>
  </kendo-grid-column>

  <kendo-grid-command-column
    [title]="t('action')"
  >
    <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem="dataItem">
      <button kendoGridEditCommand themeColor="primary">{{ t('edit') }}</button>
      <button kendoGridRemoveCommand *ngIf="!dataItem.employee">{{ t('remove') }}</button>
      <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
        {{ isNew ? t('add') : t('save') }}
      </button>
      <button kendoGridCancelCommand>
        {{ isNew ? t('discard') : t('cancel') }}
      </button>
    </ng-template>
  </kendo-grid-command-column>
</kendo-grid>

<app-delete-confirm-dialog
  [(opened)]="deletionDialogOpened"
  [message]="t('deletionMessages.ressource')"
  (confirmed)="deleteConfirmed()"
></app-delete-confirm-dialog>
</ng-container>
